import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import './styles.scss'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { ROUTE_STRINGS } from 'Utils/Constants'

// import { YOUR_NEWS_SUBSCRIPTION_TYPES } from '../../Utils' // Commented as per requirement - RGP Tags

// Commented as per requirement - RGP Tags
// const getSubscriptionLabelColor = (ele) => {
//   const colorCodes = ele?.subscription_colors || []
//   return `linear-gradient(100deg, ${colorCodes[0] || '#ccc'}, ${colorCodes[1] || colorCodes[0] || '#ccc'}, ${colorCodes[2] || colorCodes[0] || '#ccc'})`
// }

const getTagsForTierType = (tierType) => {
  if (tierType === 'all') return 'all-type'
  if (tierType === 'gold') return 'gold-type'
  if (tierType === 'platinum') return 'platinum-type'

  return 'all-type'
}

const getEditIconUrl = (tierType) => {
  if (tierType === 'all') return 'https://coffeeweb.s3.ap-south-1.amazonaws.com/your_news_edit_icon_regular.png'
  if (tierType === 'gold') return 'https://coffeeweb.s3.ap-south-1.amazonaws.com/your_news_edit_gold_icon.png'
  if (tierType === 'platinum') return 'https://coffeeweb.s3.ap-south-1.amazonaws.com/your_news_edit_icon_platinum.png'

  return 'https://coffeeweb.s3.ap-south-1.amazonaws.com/your_news_edit_icon_regular.png'
}

const SubscriptionTabItem = ({ id, title, unreadCount = 0, isActive = false, isSubscriptionLocked = false, isGlobalSlot = false, tierType = 'all', reminder, onSelect, onEdit, onLockedClick, canEdit = true }) => {
  const userDetails = getLocalUserDetails()
  const history = useHistory()

  const handleClick = (e) => {
    if (!userDetails?.isLoggedIn) {
      history.push(ROUTE_STRINGS.login)
    }
    if (isSubscriptionLocked) {
      if (onLockedClick) onLockedClick(tierType)

      return
    }

    if (e.target.closest('.subscription-tab-item__edit') || e.target.closest('.subscription-tab-item__tags')) return
    if (!onSelect) return
    onSelect({ id, title })
  }

  const handleEditClick = (e) => {
    if (!userDetails?.isLoggedIn) {
      history.push(ROUTE_STRINGS.login)
    }
    e.stopPropagation()

    if (isSubscriptionLocked) {
      if (onLockedClick) onLockedClick(tierType)

      return
    }

    if (onEdit && reminder != null && !isEditDisabled) {
      onEdit(reminder)
    }
  }

  // Commented as per requirement - RGP Tags
  // const tagCodes = getTagsForTierType(tierType)
  // const tagSubscriptions = tagCodes.map((code) => YOUR_NEWS_SUBSCRIPTION_TYPES.find((s) => s.subscription_code === code)).filter(Boolean)
  const isEditDisabled = !onEdit || reminder == null

  const isLockedButClickable = isSubscriptionLocked && onLockedClick

  return (
    <div className={`subscription-tab-item ${isActive ? 'subscription-tab-item--active' : ''} ${isSubscriptionLocked ? 'subscription-tab-item--locked' : ''}`} data-testid={`subscription-tab-${id}`}>
      <div
        className={`subscription-tab-item__main ${isSubscriptionLocked && !isLockedButClickable ? 'subscription-tab-item__main--disabled' : ''}`}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleClick(e)
        }}
        role="button"
        tabIndex={isLockedButClickable || !isSubscriptionLocked ? 0 : -1}
      >
        <button type="button" className={`subscription-tab-item__edit ${isEditDisabled ? 'subscription-tab-item__edit--disabled' : ''}`} onClick={handleEditClick} disabled={isEditDisabled} aria-label="Edit">
          <img src={getEditIconUrl(tierType)} alt="Edit" className="subscription-tab-item__edit-icon" />
        </button>
        <span className={`${getTagsForTierType(tierType)} 'subscription-tab-item__title'`}>{title}</span>
        {unreadCount > 0 && <span className="subscription-tab-item__badge">{unreadCount}</span>}
        {isSubscriptionLocked && (
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#7b7b7b">
              <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm296.5-143.5Q560-327 560-360t-23.5-56.5Q513-440 480-440t-56.5 23.5Q400-393 400-360t23.5 56.5Q447-280 480-280t56.5-23.5ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
            </svg>
          </div>
        )}

        {/* RGP Tags Commented Out as per the requirement */}
        {/* <div className="subscription-tab-item__tags published_for_sub_div" data-testid="subscription-code">
          {tagSubscriptions.map((ele, index) => (
            <span
              key={index}
              className="subscription-tab-item__tag eachLabeling"
              style={{
                backgroundSize: '400% 400%',
                backgroundImage: getSubscriptionLabelColor(ele),
                animation: 'gradient 7s ease infinite',
                color: 'white',
                borderRadius: '4px',
                fontSize: '12px',
                padding: '1px 7px',
                margin: '1px 2px'
              }}
            >
              {ele?.subscription_code}
            </span>
          ))}
        </div> */}
      </div>
    </div>
  )
}

export default SubscriptionTabItem
